import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f10f08bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fullsize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      class: "fullsize",
      animated: "",
      style: {"--el-skeleton-color":"#AFBEC7"}
    }, {
      template: _withCtx(() => [
        _createVNode(_component_el_skeleton_item, { variant: "rect" })
      ]),
      _: 1
    })
  ]))
}